import moment from "moment";
import { Inventory } from "./inventory";
import { Record } from "immutable";

const defaults = {
    active: true,
    available: undefined,
    brand: undefined,
    display_name: "",
    display_quantity: "",
    id: undefined,
    period_end: undefined,
    period_start: undefined,
    prebook: false,
    quantity: 0,
    sku_id: undefined,
    warehouse_id: undefined,
};

export class Replenishment extends Record(defaults) {
    declare id: string;
    declare active: boolean;
    declare available: Inventory;
    declare brand: string;
    declare quantity: number;
    declare prebook: boolean;
    declare display_name: string;
    declare display_quantity: string;
    declare period_end: moment.Moment;
    declare period_start: moment.Moment;
    declare sku_id: string;
    declare warehouse_id: string;

    constructor(args) {
        super({
            ...args,
            available: args.available && new Inventory(args.available),
            period_end: moment.utc(args.period_end),
            period_start: moment.utc(args.period_start),
        });
    }
}
